export enum ConsentType {
    None = 0,
    Account = 1,
    Payment = 2,
    Funds = 3
}
